import {ListGroup, ListGroupItem} from "inferno-bootstrap";
import {AppState} from "../../services/configuration";
import {IChatQueue} from "../../utils/types";

const findName = (names: Array<{ name: string, language: string }>, address: string) => {
	let language = AppState.language;
	if (language.length > 2) {
		language = language.split("-")[0];
	}
	language = language.length === 2 ? language : "en";
	let result = address;
	for (const name of names) {
		if (name.language === language) {
			// Found the name
			return name.name;
		}
		if (name.language === "en") {
			// Save english translation
			result = name.name;
		}
	}
	return result;
};

export function QueueList(props: { queues: IChatQueue[], items: Array<{ address: string, id: string, name: string }>, activeQueue: string, setActive: (activeQueue: string) => void }) {
	// Don't render one queue
	if (props.items.length < 2) {
		return;
	}

	if (props.queues.length === 0) {
		return (
			<ListGroup>
				{
					props.items.map((item) =>
						<ListGroupItem onClick={() => props.setActive(item.address)} className="login-queues" action active={item.address === props.activeQueue}> {item.name} </ListGroupItem>)
				}
			</ListGroup>
		);
	} else {
		return (
			<ListGroup>
				{
					props.queues.map((item: any) =>
						//<ListGroupItem onClick={() => props.setActive(item.address)} className="login-queues" action
						//active={item.address === props.activeQueue}> {findName(item.names, item.address)} </ListGroupItem>)
						<ListGroupItem onClick={() => props.setActive(item.address)} className="login-queues" action
							active={item.address === props.activeQueue}>{item.name}</ListGroupItem>)
				}
			</ListGroup>
		);
	}
}
